import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerCaricaFatturePAModalComponent } from './worker-carica-fattura-pa-modal';

export const WorkerCaricaFatturePAModalModule: string = ng
    .module('worker-carica-fattura-pa-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerCaricaFatturePAModalComponent', WorkerCaricaFatturePAModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/worker-carica-fattura-pa-modal/worker-carica-fattura-pa-modal.module.ts